<script lang="ts" setup>
import { useCityStore } from '~/store/city'

const cityStore = useCityStore()
</script>

<template>
  <a
    class="flex items-center text-nowrap !no-underline [&_span]:hover:!text-main-green"
    href="#"
  >
    <SvgIcon class="!size-4 text-main-green md:!size-5" name="outlined/location" />

    <span
      class="
        pl-1.5 text-sm leading-[1.71] tracking-[-0.01em] text-main-dark transition-colors duration-200
        md:text-base md:leading-[1.37]
      "
    >
      {{ cityStore.selectedCity?.name || 'Выберите город' }}
    </span>
  </a>
</template>
